// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".comment_textarea_head-3iku1Ljx {\n    margin-bottom: 8px;\n    margin-top: 30px;\n}\n\n.tips-3Sra-CaO {\n    font-size: 12px;\n    color: #999 !important;\n}\n\n.right_box-x8e_9DA5 {\n    float: right;\n}\n\n.count-2tGLSVt_ a {\n    color: #f54343;\n    text-decoration: none\n}\n\n.count-2tGLSVt_ a:hover {\n    text-decoration: underline;\n}\n\n.num-3THq-SS5 {\n    font: 18px georgia;\n    color: #f54343;\n}\n\n.txt-3nezrmDB {\n    font-size: 12px;\n    color: #999;\n}\n\n.line-2RHWiqhz {\n    padding: 0 8px;\n    font-size: 14px;\n    color: #999;\n}\n", ""]);
// Exports
exports.locals = {
	"comment_textarea_head": "comment_textarea_head-3iku1Ljx",
	"tips": "tips-3Sra-CaO",
	"right_box": "right_box-x8e_9DA5",
	"count": "count-2tGLSVt_",
	"num": "num-3THq-SS5",
	"txt": "txt-3nezrmDB",
	"line": "line-2RHWiqhz"
};
module.exports = exports;
